// Character counter
function countCharacters(countCnt: HTMLTextAreaElement, maximumCharacters: number): void {
    const countCharsLeft: HTMLElement | null = document.querySelector('.js-chars-left');

    if (countCnt.value.length >= maximumCharacters) {
        countCnt.value = countCnt.value.substring(0, maximumCharacters);
        countCnt.scrollTop = countCnt.scrollHeight;
    }

    if (countCharsLeft) {
        countCharsLeft.innerText = (maximumCharacters - countCnt.value.length).toString();
    }
}

export default function attachCharacterCounterEvents(maximumCharacters: number): void {
    const countContainer: HTMLTextAreaElement | null = document.querySelector('.js-chars-count');
    const countCharsLeft: HTMLElement | null = document.querySelector('.js-chars-left');

    if (countContainer && countCharsLeft) {
        countCharsLeft.innerText = `${maximumCharacters}`;

        countContainer.addEventListener('keydown', (e: Event) => {
            countCharacters(countContainer, maximumCharacters);
        });

        countContainer.addEventListener('change', (e: Event) => {
            countCharacters(countContainer, maximumCharacters);
        });
    }
}
